import { render, staticRenderFns } from "./ItemListColumnHeader.vue?vue&type=template&id=5575a15f&"
import script from "./ItemListColumnHeader.vue?vue&type=script&lang=js&"
export * from "./ItemListColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5575a15f')) {
      api.createRecord('5575a15f', component.options)
    } else {
      api.reload('5575a15f', component.options)
    }
    module.hot.accept("./ItemListColumnHeader.vue?vue&type=template&id=5575a15f&", function () {
      api.rerender('5575a15f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ItemListColumnHeader.vue"
export default component.exports